/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import SelectQuestion from '../../../components/mobile/speak-doctor/SelectQuestion';
import DateQuestion from '../../../components/mobile/speak-doctor/DateQuestion';
import TextAreaQuestion from '../../../components/mobile/speak-doctor/TextAreaQuestion';

const mobileNewParentRoutes = [
  {
    id: '1',
    path: '/speak-doctor/pregnancy/new-parent/when-baby-born',
    component: (props) => <DateQuestion {...props} />,
    props: {
      fieldName: 'BabyBorndate',
      prevRoutePath: '/speak-doctor/pregnancy',
      nextRoutePath: '/speak-doctor/pregnancy/new-parent/where-baby-delivered',
      title: 'speak-doctor:pregnant.newParent.whenBabyBorn',
      subtitle: 'speak-doctor:pregnant.newParent.selectDateBelow',
      isLastQuestion: false,
    },
  },
  {
    id: '2',
    path: '/speak-doctor/pregnancy/new-parent/where-baby-delivered',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'BabyDeliveredAt',
      prevRoutePath: '/speak-doctor/pregnancy/new-parent/when-baby-born',
      nextRoutePath: '/speak-doctor/pregnancy/new-parent/how-baby-delivered',
      title: 'speak-doctor:pregnant.newParent.whereBabyDelivered',
      subtitle: '',
      isLastQuestion: false,
      options: [
        {
          value: 'Hospital',
          label: 'speak-doctor:pregnant.newParent.options1.hosiptal',
        },
        {
          value: 'Private Clinic',
          label: 'speak-doctor:pregnant.newParent.options1.privateClinic',
        },
        {
          value: 'Home',
          label: 'speak-doctor:pregnant.newParent.options1.home',
        },
        {
          value: 'Other',
          label: 'speak-doctor:pregnant.newParent.options1.other',
        }
      ],
      boxWidth: '100%'
    },
  },
  {
    id: '3',
    path: '/speak-doctor/pregnancy/new-parent/how-baby-delivered',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'HowBabyDelivered',
      prevRoutePath: '/speak-doctor/pregnancy/new-parent/where-baby-delivered',
      nextRoutePath: '/speak-doctor/pregnancy/new-parent/speak-to-doctor',
      title: 'speak-doctor:pregnant.newParent.howBabyDelivered',
      subtitle: '',
      isLastQuestion: false,
      options: [
        {
          value: 'Natural',
          label: 'speak-doctor:pregnant.newParent.options2.natural',
        },
        {
          value: 'Cesarean',
          label: 'speak-doctor:pregnant.newParent.options2.cesarean',
        }
      ],
      boxWidth: '100%'
    },
  },
  {
    id: '4',
    path: '/speak-doctor/pregnancy/new-parent/speak-to-doctor',
    component: (props) => <TextAreaQuestion {...props} />,
    props: {
      fieldName: 'WhatWouldLikeToSpeakToDoctor',
      prevRoutePath: '/speak-doctor/pregnancy/new-parent/how-baby-delivered',
      nextRoutePath: '',
      title: 'speak-doctor:pregnant.currentPregnant.whatYouLikeSpeakToDoctor',
      subtitle: '',
      isLastQuestion: true,
    },
  },
];

export const getMobileNewParentRoutes = () => mobileNewParentRoutes;
